import { Hint, MediaImage, Placeholder, Slot } from "./MediaSlot.styled";

export default function MediaSlot({ src, label, hint, alt, dark, minHeight, cover, fit }) {
	if (!src) {
		return (
			<Placeholder minHeight={minHeight}>
				{label || "Drop a screenshot here"}
				{hint && <Hint>{hint}</Hint>}
			</Placeholder>
		);
	}

	return (
		<Slot dark={dark} minHeight={minHeight} $cover={cover} $fit={fit}>
			<MediaImage src={src} alt={alt || label || ""} $cover={cover} $fit={fit} />
		</Slot>
	);
}
